module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["step-body"]
  }, [_c('div', {
    ref: "wrapper",
    staticClass: ["step-item-wrapper"],
    style: [_vm.rowStyles]
  }, [_c('div', {
    staticClass: ["step-flow-wrapper"]
  }, [_vm._l((_vm.formattedList), function(item, index) {
    return [(index < _vm.formattedList.length - 1) ? _c('div', {
      key: 'line' + index,
      class: ['step-line', _vm.showLine && 'hline'],
      style: Object.assign(item.lineStyles, _vm.linePos[index])
    }) : _vm._e()]
  })], 2), _vm._l((_vm.formattedList), function(item, index) {
    return _c('div', {
      key: 'desc' + index,
      ref: 'item' + index,
      refInFor: true,
      staticClass: ["step-item"],
      style: [item.columnStyles]
    }, [_c('div', {
      ref: 'point' + index,
      refInFor: true,
      class: ['step-point'],
      style: [item.pointStyles]
    }), _c('text', {
      class: ['step-desc'],
      style: [item.descStyles]
    }, [_vm._v(_vm._s(item.desc))])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-6f217df2!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-step-flow-h/index.vue
// module id = 639
// module chunks = 0 1